"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeClear = exports.getScripts = exports.getAssetsUrl = exports.checkExperimentsForAdsEligibility = void 0;
var PROD_UCI_ASSETS_URL = 'https://www.uciservice.com/assets/';
var INT_UCI_ASSETS_URL = 'https://www.uciservice.com/assets-int/';
var PROD_ENV = 3;
function checkExperimentsForAdsEligibility(experiment) {
    if (!experiment) {
        return true;
    }
    var adsFeatureGate = experiment && experiment.exposures && experiment.exposures["meso_ads_feature_gate"];
    if ((adsFeatureGate === null || adsFeatureGate === void 0 ? void 0 : adsFeatureGate.bucket) === 1) {
        return false;
    }
    return true;
}
exports.checkExperimentsForAdsEligibility = checkExperimentsForAdsEligibility;
function getAssetsUrl(env) {
    return env === PROD_ENV ? PROD_UCI_ASSETS_URL : INT_UCI_ASSETS_URL;
}
exports.getAssetsUrl = getAssetsUrl;
function getScripts(env) {
    var UCI_ASSETS_URL = getAssetsUrl(env);
    var scripts = [
        {
            src: UCI_ASSETS_URL + 'meso-loaders/meso-loader.js',
            type: 'module',
        },
        {
            src: UCI_ASSETS_URL + 'md-libs/1.0/ss-resources/meso-ssads.bundle.js',
            defer: true
        }
    ];
    return scripts;
}
exports.getScripts = getScripts;
function initializeClear() {
    // Clear the ADS cache.
    window.meso = window.meso || {};
    window.meso.initialize = window.meso.initialize || [];
    window.meso.initialize.push({ type: 'clear' });
}
exports.initializeClear = initializeClear;
//# sourceMappingURL=index.js.map